module.exports = __webpack_public_path__ + "img/applets.3aebcb7b.png";